(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858],{

/***/ 26690:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/account",
      function () {
        return __webpack_require__(54135);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Alert(param) {
    var children = param.children, className = param.className, type = param.type, open = param.open, setOpen = param.setOpen;
    var typeIcon = function(type) {
        switch(type){
            case "warning":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                    })
                });
            case "error":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
                    })
                });
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                    })
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                    })
                });
        }
    };
    var typeColor = function(type) {
        switch(type){
            case "warning":
                return "bg-yellow-100 border-yellow-200 text-yellow-600";
            case "error":
                return "bg-red-100 border-red-200 text-red-600";
            case "success":
                return "bg-green-100 border-green-200 text-green-600";
            default:
                return "bg-indigo-100 border-indigo-200 text-indigo-500";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            var timer = setTimeout(function() {
                setOpen(false);
            }, 2500);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-2 rounded-sm text-sm border ".concat(typeColor(type)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full justify-between items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                typeIcon(type),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: children
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "opacity-70 hover:opacity-80 ml-3 mt-[3px]",
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sr-only",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "w-4 h-4 fill-current",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Alert);


/***/ }),

/***/ 86707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Button_loading = function(param) {
    var text_color = param.text_color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 ".concat(text_color),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button_loading);


/***/ }),

/***/ 33615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_Transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1193);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73935);






function Sidepan(param) {
    var children = param.children, id = param.id, sidepanOpen = param.sidepanOpen, setSidepanOpen = param.setSidepanOpen, justify_align = param.justify_align, closeByOutsideClick = param.closeByOutsideClick, closeByEscClick = param.closeByEscClick, sidepan_component_styles = param.sidepan_component_styles, custom_content_box_styles = param.custom_content_box_styles, hide_back_shadow = param.hide_back_shadow, fixed_main_width = param.fixed_main_width;
    var modalContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setMounted(true);
    }, []);
    // close on click outside
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick) {
            var clickHandler = function(param) {
                var target = param.target;
                var ref;
                if (!sidepanOpen || modalContent.current.contains(target) || (target === null || target === void 0 ? void 0 : (ref = target.id) === null || ref === void 0 ? void 0 : ref.includes("react-select"))) return;
                setSidepanOpen(false);
            };
            document.addEventListener("click", clickHandler);
            return function() {
                return document.removeEventListener("click", clickHandler);
            };
        }
    });
    // close if the esc key is pressed
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick || closeByEscClick) {
            var keyHandler = function(param) {
                var keyCode = param.keyCode;
                if (!sidepanOpen || keyCode !== 27) return;
                setSidepanOpen(false);
            };
            document.addEventListener("keydown", keyHandler);
            return function() {
                return document.removeEventListener("keydown", keyHandler);
            };
        }
    });
    // Return null during SSR
    if (!mounted) return null;
    // Only create portal on client-side
    var portalElement =  true ? document.body : 0;
    if (!portalElement) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_5__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            hide_back_shadow !== true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "fixed inset-0 bg-gray-900 bg-opacity-30 z-100 transition-opacity",
                show: sidepanOpen,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0",
                enterEnd: "opacity-100",
                leave: "transition ease-out duration-100",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: id,
                className: [
                    "fixed inset-0 z-100  overflow-hidden flex items-center    transform ",
                    justify_align ? "justify-".concat(justify_align) : "justify-end",
                    fixed_main_width ? fixed_main_width : "w-auto", 
                ].join(" "),
                role: "dialog",
                "aria-modal": "true",
                show: sidepanOpen,
                enter: "transition ease-in-out duration-200",
                enterStart: "opacity-0 translate-y-4",
                enterEnd: "opacity-100 translate-y-0",
                leave: "transition ease-in-out duration-200",
                leaveStart: "opacity-100 translate-y-0",
                leaveEnd: "opacity-0 translate-y-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: modalContent,
                    className: [
                        "bg-white   shadow-lg overflow-auto  rounded-md  max-h-full  ",
                        sidepan_component_styles !== null && sidepan_component_styles !== void 0 ? sidepan_component_styles : "",
                        custom_content_box_styles, 
                    ].join(" "),
                    children: children
                })
            })
        ]
    }), portalElement);
}
/* harmony default export */ __webpack_exports__["Z"] = (Sidepan);


/***/ }),

/***/ 54135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ My_Account; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Header2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15592);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48777);
/* harmony import */ var _components_settings_AccountPanel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81263);
/* harmony import */ var _layouts_SettingsLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96583);
/* harmony import */ var constant_check_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44902);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);








function My_Account() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    return (0,constant_check_auth__WEBPACK_IMPORTED_MODULE_6__/* .check_login */ .f)(router, true) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_SettingsLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_settings_AccountPanel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [43430,91586,68583,48777,433,15592,17039,43109,49774,92888,40179], function() { return __webpack_exec__(26690); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);